import {
  DocumentUnknown,
  Image,
  Pdf,
  Txt,
  Zip,
  BlockStorage,
  FlowConnection,
  TableBuilt,
  Template,
} from "@carbon/icons-react";
import { Icons } from "./icon";

export enum FileTypes {
  Excel = 1,
  World = 2,
  Powerpoint = 3,
  OneNote = 4,
  Image = 5,
  Zip = 6,
  Text = 7,
  Pdf = 8,
  Unknown = 9,
  Folder = 10,
  Project = 11,
  Dataform = 12,
  TaskDesign = 13,
  Workflow = 14,
}

export const getFileTypeByExtension = (
  extension: string | null | undefined
) => {
  if (extension === null) return FileTypes.Folder;
  if (!extension) return FileTypes.Unknown;
  let strCheck = extension;
  const strCheckArr = extension.split("/");
  if (strCheckArr.length) {
    strCheck = strCheckArr[strCheckArr.length - 1];
  }
  if (strCheck.includes(".")) {
    const strArr = strCheck.split(".");
    strCheck = strArr[strArr.length - 1];
  }

  if (
    [
      "xlsx",
      "xlsm",
      "xls",
      "csv",
      "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ].includes(strCheck)
  )
    return FileTypes.Excel;
  else if (
    [
      "doc",
      "docx",
      "msword",
      "vnd.openxmlformats-officedocument.wordprocessingml.document",
    ].includes(strCheck)
  )
    return FileTypes.World;
  else if (["pptx", "ppt"].includes(strCheck)) return FileTypes.Powerpoint;
  else if (["one"].includes(strCheck)) return FileTypes.OneNote;
  else if (["jpg", "png", "jpeg", "gif"].includes(strCheck))
    return FileTypes.Image;
  else if (["zip"].includes(strCheck)) return FileTypes.Zip;
  else if (["txt"].includes(strCheck)) return FileTypes.Text;
  else if (["pdf"].includes(strCheck)) return FileTypes.Pdf;
  else if (["prj"].includes(strCheck)) return FileTypes.Project;
  else if (["df"].includes(strCheck)) return FileTypes.Dataform;
  else if (["ds", "td"].includes(strCheck)) return FileTypes.TaskDesign;
  else if (["wf"].includes(strCheck)) return FileTypes.Workflow;
  else return FileTypes.Unknown;
};

export interface IFileIconProps {
  extension: string | null | undefined;
  size?: number;
  className?: string;
}

export default function FileIcon({
  extension,
  size = 22,
  className = "",
}: IFileIconProps) {
  switch (getFileTypeByExtension(extension)) {
    case FileTypes.Excel:
      return (
        <Icons.TGExcel
          size={size}
          aria-label="Excel"
          className={className}
        ></Icons.TGExcel>
      );
    case FileTypes.World:
      return (
        <Icons.TGWorld
          size={size}
          aria-label="World"
          className={className}
        ></Icons.TGWorld>
      );
    case FileTypes.Powerpoint:
      return (
        <Icons.TGPowerpoint
          size={size}
          aria-label="Powerpoint"
          className={className}
        ></Icons.TGPowerpoint>
      );
    case FileTypes.OneNote:
      return (
        <Icons.TGOneNote
          size={size}
          aria-label="OneNote"
          className={className}
        ></Icons.TGOneNote>
      );
    case FileTypes.Folder:
      return (
        <Icons.TGFolder
          size={size}
          aria-label="Folder"
          className={className}
        ></Icons.TGFolder>
      );
    case FileTypes.Image:
      return (
        <Image
          size={size}
          aria-label="Image"
          className={className}
        ></Image>
      );
    case FileTypes.Zip:
      return (
        <Zip
          size={size}
          aria-label="Zip"
          className={className}
        ></Zip>
      );
    case FileTypes.Text:
      return (
        <Txt
          size={size}
          aria-label="Text"
          className={className}
        ></Txt>
      );
    case FileTypes.Pdf:
      return (
        <Pdf
          size={size}
          aria-label="Pdf"
          className={className}
        ></Pdf>
      );
    case FileTypes.Project:
      return (
        <Template
          size={size}
          aria-label="Project"
          color="purple"
          className={className}
        ></Template>
      );
    case FileTypes.Dataform:
      return (
        <TableBuilt
          size={size}
          aria-label="Dataform"
          color="hsl(var(--file-type-data-form-icon))"
          className={className}
        ></TableBuilt>
      );
    case FileTypes.TaskDesign:
      return (
        <BlockStorage
          size={size}
          aria-label="TaskDesign"
          color="hsl(var(--file-type-task-design-icon))"
          className={className}
        ></BlockStorage>
      );
    case FileTypes.Workflow:
      return (
        <FlowConnection
          size={size}
          aria-label="Workflow"
          color="hsl(var(--file-type-work-flow-icon))"
          className={className}
        ></FlowConnection>
      );
    default:
      return (
        <DocumentUnknown
          size={size}
          aria-label="Unknown"
          className={className}
        ></DocumentUnknown>
      );
  }
}
